import { render, staticRenderFns } from "./PanoramaSpot.vue?vue&type=template&id=4ed8ba4a&scoped=true&"
import script from "./PanoramaSpot.vue?vue&type=script&lang=js&"
export * from "./PanoramaSpot.vue?vue&type=script&lang=js&"
import style0 from "./PanoramaSpot.vue?vue&type=style&index=0&id=4ed8ba4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8ba4a",
  null
  
)

export default component.exports